import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbs: any[] = [];
  IsMobile: boolean = false;

  constructor(private dataService: DataService, private router: Router) { }

  ngOnInitOriginal() {
    // Inicializar como un arreglo vacío
    this.breadcrumbs = [];

    // Cargar el breadcrumb desde localStorage si está disponible
    const savedBreadcrumbs = localStorage.getItem('breadcrumbs-MAO');
    if (savedBreadcrumbs) {
      this.breadcrumbs = JSON.parse(savedBreadcrumbs) || []; // Asegurarse de que sea un arreglo

    }
    this.updateBreadcrumbDisplay();

    this.dataService.currentmessageBredCrumb.subscribe(data => {
      //console.log('Data received:', data); // Verifica el contenido
      var localBread = [];
      if (data) {

        var localBreadString = localStorage.getItem('breadcrumbs-MAO');

        //localBread = localBreadString ? JSON.parse(localBreadString) : []; // Verifica si hay datos  
        localBread = localBreadString ? JSON.parse(localBreadString) : this.dataService.currentmessageBredCrumb;

        //const breadcrumb = localBread.find(b => b.component === currentPath);
      }



    });





    // Escuchar eventos de navegación
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateBreadcrumbDisplay();
      }
    });
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const isMobile = window.innerWidth <= 760;
    if (isMobile) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }

  ngOnInitBK2() {
    // Inicializar como un arreglo vacío
    this.breadcrumbs = [];

    // Cargar el breadcrumb desde localStorage si está disponible
    const savedBreadcrumbs = localStorage.getItem('breadcrumbs-MAO');
    if (savedBreadcrumbs) {
      this.breadcrumbs = JSON.parse(savedBreadcrumbs) || []; // Asegurarse de que sea un arreglo
    }

    // Suscribirse a los cambios en el breadcrumb
    this.dataService.currentmessageBredCrumb.subscribe(data => {
      // console.log('Data received:', data); // Verifica el contenido

      // Validar si hay datos y que el servicio ya se haya completado
      if (data && data.length > 0) {
        // Cargar los breadcrumbs
        var localBreadString = localStorage.getItem('breadcrumbs-MAO');
        var localBread = localBreadString ? JSON.parse(localBreadString) : []; // Asegurarse de que sea un arreglo

        // Si el localBread está vacío, usar el data del servicio
        if (localBread.length === 0) {
          localBread = this.dataService.currentmessageBredCrumb; // O cualquier lógica para obtener los datos
        }

        // Ahora que tenemos datos, podemos proceder a actualizar el breadcrumb
        this.updateBreadcrumbDisplay();
      } else {
        // console.log('No data available in currentmessageBredCrumb.');
      }
    });

    // Ejecutar la actualización inicial, sólo si hay datos en el local storage
    if (this.breadcrumbs.length > 0) {
      this.updateBreadcrumbDisplay();
    }
  }

  ngOnInit() {

    const isMobile = window.innerWidth <= 760;
    if (isMobile) {
      // Aplicar reordenamiento solo en vista móvil
      this.IsMobile = true;
    }


    this.breadcrumbs = [];

    const savedBreadcrumbs = localStorage.getItem('breadcrumbs-MAO');
    if (savedBreadcrumbs) {
      this.breadcrumbs = JSON.parse(savedBreadcrumbs) || [];
    }

    // Inicializar localBread
    let localBread: any[] = [];

    // Obtener localBread del localStorage o del servicio
    const localBreadString = localStorage.getItem('breadcrumbs-MAO');

    if (localBreadString) {
      localBread = JSON.parse(localBreadString);
      this.updateBreadcrumbDisplay(); // O cualquier otra lógica que dependa de localBread
    } else {
      this.dataService.currentmessageBredCrumb.subscribe(data => {
        if (data === null || data === undefined || data.trim() === '') {
          //console.log('No hay datos en currentmessageBredCrumb.');
        } else {
          localBread = JSON.parse(data); // Suponiendo que `data` es un string que puede ser parseado
          // Llamar a la función que necesite usar localBread aquí
          this.updateBreadcrumbDisplay(); // O cualquier otra lógica que dependa de localBread
        }
      });
    }

    this.dataService.currentmessageBredCrumb.subscribe(data => {
      //console.log('Data received:', data); 

      if (data && data.length > 0) {
        var localBreadString = localStorage.getItem('breadcrumbs-MAO');
        var localBread = localBreadString ? JSON.parse(localBreadString) : [];

        // Si el localBread está vacío, considera cómo manejarlo.
        if (localBread.length === 0) {
          // Podrías omitir esta línea si no hay un valor predeterminado a usar.
          localBread = [];
        }
      } else {
        //console.log('No data available in currentmessageBredCrumb.');
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateBreadcrumbDisplay();
      }
    });
  }







  updateBreadcrumbDisplay() {
    const urlSegments = this.router.url.split('/'); // Dividir la URL en segmentos
    const currentPath = urlSegments[urlSegments.length - 1]; // Obtener el último segmento de la URL
    const secondLastSegment = urlSegments.length > 2 ? urlSegments[urlSegments.length - 2] : null; // Obtener el penúltimo segmento (el ID o el path)

    var localBread = [];
    var localBreadString = localStorage.getItem('breadcrumbs-MAO');

    // Verificar si hay datos en localStorage
    localBread = localBreadString ? JSON.parse(localBreadString) : this.dataService.currentmessageBredCrumb;

    if (localBreadString)
      localBread = JSON.parse(localBreadString);
    else {

      this.dataService.currentmessageBredCrumb.subscribe(data => {
        if (data === null || data === undefined || data.trim() === '') {
          //console.log('No hay datos en currentmessageBredCrumb.');
        } else {
          //console.log('Datos recibidos:', data);
        }
      });
    }


    let breadcrumb;

    if (secondLastSegment && !isNaN(Number(secondLastSegment))) {
      // Si el segundo último segmento es un número, significa que es un ID
      const previousPath = urlSegments[urlSegments.length - 3]; // Obtener el tercer último segmento (componente)

      // Buscar en los breadcrumbs usando el tercer último segmento como componente
      breadcrumb = localBread.find(b => b.component === previousPath && b.id == secondLastSegment);
    } else {
      // Buscar solo por el path
      breadcrumb = localBread.find(b => b.component === currentPath);
    }

    if (breadcrumb) {
      // Aquí construimos la ruta completa que deseamos mostrar
      this.breadcrumbs = [
        {
          component: breadcrumb.component,
          breadcrumb: breadcrumb.breadcrumb, // El nombre del padre
          child: breadcrumb.child            // El nombre del hijo (si aplica)
        }
      ];
    } else {
      if (currentPath == "dynamicdashboard") {
        this.breadcrumbs = [
          {
            component: "",
            breadcrumb: "", // El nombre del padre
            child: "Dashboard"
          }
        ]
      }
      else
        this.breadcrumbs = [];
    }
  }

}
